export default __webpack_public_path__ + "static/media/02.62af1ef4.svg";